const FontWeight = {
	semi: "600",
	bold: "800",
	normal: "400"
}

export default FontWeight
